import React, { useMemo, useRef, useContext } from "react";
import EditMasterCampaignV2 from "../../Modals/EditMasterCampaignV2";
import { DataTableContext } from "../Tabs/Overview";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import { ViewMasterCampaignsContext } from "../index";

export default () => {
	// Define a ref that will be used to open and close the modal
	const dpRef = useRef();

	// Import various contexts
	const { checkboxSelections, dataProvider, dataTableApi } = useContext(DataTableContext);
	const { platforms, gridConfig, refreshData, enabledPlatformAPIs, permissionedDataKeys } = useContext(ViewMasterCampaignsContext);

	// Property used to disable the Trigger button given specific criteria
	const disabled = useMemo(() => {
		return checkboxSelections?.selectedMasterCampaigns?.length != 1 || false;
	}, [checkboxSelections]);

	// Extract the actual selected campaign data from the overall data set
	const selectedCampaignData = useMemo(() => {
		if (!disabled) {
			const selection = checkboxSelections?.selectedMasterCampaigns?.[0];
			return dataProvider?.data?.find(({ MasterCampaignID }) => MasterCampaignID == selection) || {};
		}
		return {};
	}, [checkboxSelections, disabled, dataProvider]);

	// Define a button that can be rendered wherever the client desires
	const Trigger = () => (
		<Button
			display={BUTTON_DISPLAY.TEXT}
			style={{ width: "fit-content" }}
			onClick={() => {
				dpRef?.current?.triggerOpenClose?.();
			}}
			disabled={disabled}
			id="editPrimaryCampaignButton"
			data-tracking-id-alt="edit-primary-campaign-button"
		>
			Edit Primary Campaign
		</Button>
	);

	// Define  the component that should be displayed when the trigger is clicked
	const DisplayedComponent = () => {
		if (gridConfig && platforms && selectedCampaignData) {
			return (
				<EditMasterCampaignV2
					editMasterRef={(ref) => {
						dpRef.current = ref;
					}}
					permissionedDataKeys={permissionedDataKeys}
					config={gridConfig}
					mediaChannelsPlatforms={platforms}
					totalPlatforms={platforms?.length}
					data={selectedCampaignData}
					// reloadGrid={refreshData}
					enabledPlatformAPIs={enabledPlatformAPIs}
					reloadGrid={() => {
						dataTableApi?.current?.rowSelectionManager?.tree?.selectNode?.(false);
						setTimeout(() => dataProvider.update(), 1);
					}}
				/>
			);
		}
		return <></>;
	};

	// Return a memoized object containing both of these components
	return useMemo(
		() => ({ Trigger, DisplayedComponent }),
		[dataProvider, platforms, gridConfig, refreshData, selectedCampaignData, disabled, enabledPlatformAPIs, permissionedDataKeys]
	);
};
